"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallToAction = void 0;

var react_1 = __importDefault(require("react"));

var elements_1 = require("../../elements");

var utils_1 = require("../../utils");

var CallToAction = function CallToAction(_a) {
  var ctaHeader = _a.ctaHeader,
      ctaText = _a.ctaText,
      primaryButtonText = _a.primaryButtonText,
      primaryButtonAction = _a.primaryButtonAction,
      primaryButtonType = _a.primaryButtonType,
      secondaryButtonText = _a.secondaryButtonText,
      secondaryButtonAction = _a.secondaryButtonAction,
      secondaryButtonType = _a.secondaryButtonType,
      theme = _a.theme;
  var style = "flex flex-col md:flex-row " + (theme ? theme.body.backgroundColor : 'bg-gray-100') + " " + (theme ? theme.body.textColor : 'text-gray-800');
  return react_1["default"].createElement("div", {
    className: style
  }, react_1["default"].createElement("div", {
    className: "w-full md:w-3/4 md:mr-6"
  }, react_1["default"].createElement(elements_1.TitleAbstract, {
    theme: theme,
    marginBottom: true
  }, ctaHeader), react_1["default"].createElement(elements_1.TextLead, {
    theme: theme,
    marginBottom: true
  }, ctaText)), react_1["default"].createElement("div", {
    className: "flex flex-col justify-center items-center w-full md:w-1/4 md:mt-5"
  }, react_1["default"].createElement("div", {
    className: "mb-4 mt-4 md:mb-6 md:mt-6"
  }, react_1["default"].createElement(elements_1.ButtonRegular, {
    text: primaryButtonText,
    onClick: function onClick() {
      return (0, utils_1.openUrl)(primaryButtonAction);
    },
    type: primaryButtonType ? primaryButtonType : elements_1.ButtonType.tertiary
  })), react_1["default"].createElement("div", {
    className: "mb-4 md:mb-6"
  }, react_1["default"].createElement(elements_1.ButtonRegular, {
    text: secondaryButtonText,
    onClick: function onClick() {
      return (0, utils_1.openUrl)(secondaryButtonAction);
    },
    type: secondaryButtonType ? secondaryButtonType : elements_1.ButtonType.primary
  }))));
};

exports.CallToAction = CallToAction;